import React from 'react';
import { useBookingContext } from '../context';
import { isTimeBetweenRange, areTimeRangesCollided } from '../utils';
import moment from 'moment';

export default ({ booking, courtDetails }) => {
  const { setTime, startTime, endTime, resetTime, setCourt, court } = useBookingContext();
  const borderColor = booking.price === 200 ? 'border-lower-price' : 'border-higher-price';
  const selectedBorder =
    court?.courtId === courtDetails.courtId &&
    (booking.time === startTime || booking.time === endTime ? 'border-selected' : '');
  const middleBoder =
    court?.courtId === courtDetails.courtId &&
    isTimeBetweenRange(booking.time, startTime, endTime, '()')
      ? 'middle-selected-border'
      : '';
  return (
    <div
      className={`${borderColor} booking-button court__item js-court__item o-btn o-btn__fourth o-btn-rewright-width ${
        !booking.isFree ? 'disabled' : ''
      } ${selectedBorder} ${middleBoder} ${
        court?.courtId === courtDetails.courtId && booking.time === startTime && !!endTime
          ? 'start-border'
          : ''
      } ${court?.courtId === courtDetails.courtId && booking.time === endTime ? 'end-border' : ''}`}
      onClick={() => {
        setCourt({
          courtName: courtDetails.courtName,
          courtId: courtDetails.courtId
        });
        if (startTime && courtDetails.courtId !== court?.courtId) return resetTime();
        if (booking.time === startTime && !endTime) {
          resetTime();
        }
        if ((!startTime || !endTime) && (booking.time < startTime || booking.time > endTime))
          return;
        if (startTime && !endTime) {
          if (moment(booking.time, 'HH:mm').diff(moment(startTime, 'HH:mm'), 'hours') < 1) return;
          const selectedSlots = (courtDetails.slots || []).filter((slot) =>
            areTimeRangesCollided(startTime, booking.time, slot.start, slot.end)
          );
          const isCollided =
            selectedSlots.length === 0 || selectedSlots.some((slot) => slot.available === false);
          if (isCollided) return;
        }
        if (!booking.isFree) return;
        setTime(booking.time);
      }}>
      <span className="court__time">{booking.time}</span>
    </div>
  );
};
